import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"
import { UsuarioReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/UsuarioReadingFiltersDtoIPagedEnumerable"

export interface UsuarioReadingFiltersAdaptedProps
  extends UsuarioReadingFiltersDtoProps {
  "Persona.Apellidos"?: UsuarioReadingFiltersDtoProps["apellidos"]
  "DepartamentoUsuarios.Count"?: UsuarioReadingFiltersDtoProps["departamentos"]
  "Persona.Nombre"?: UsuarioReadingFiltersDtoProps["nombre"]
}

export default (lista: UsuarioReadingFiltersDtoIPagedEnumerableProps) =>
  lista?.items?.map(
    (
      userData: UsuarioReadingFiltersDtoProps
    ): UsuarioReadingFiltersAdaptedProps => ({
      id: userData.id,
      apellidos: userData.apellidos,
      "Persona.Apellidos": userData.apellidos,
      departamentos: userData.departamentos,
      "DepartamentoUsuarios.Count": userData.departamentos,
      email: userData.email,
      nombre: userData.nombre,
      "Persona.Nombre": userData.nombre,
      verificado: userData.verificado,
    })
  )
